import { defineMessages } from 'react-intl';

export default defineMessages({
    account: {
        id: 'header.links.Account',
        defaultMessage: 'Account'
    },
    faq: {
        id: 'header.links.FAQ',
        defaultMessage: 'FAQ'
    },
    logout: {
        id: 'header.links.Logout',
        defaultMessage: 'Logout'
    },
    myClaims: {
        id: 'header.links.myClaims',
        defaultMessage: 'My Claims'
    },
    myBillings: {
        id: 'header.links.myBillings',
        defaultMessage: 'My Billing'
    },
    home: {
        id: 'header.links.home',
        defaultMessage: 'Home'
    },
    myDocuments: {
        id: 'header.links.myDocuments',
        defaultMessage: 'My Documents'
    },
    reportClaim: {
        id: 'gateway.views.new-quote.Report A Claim',
        defaultMessage: 'Report A Claim'
    },
    printLiability: {
        id: 'header.links.Print Liability Slip',
        defaultMessage: 'Print Liability Slip'
    },
    makePayment: {
        id: 'header.links.gateway.views.new-quot.Make A Payment',
        defaultMessage: 'Make A Payment'
    },
    goPaperlessHeading: {
        id: 'header.links.Go Paperless',
        defaultMessage: 'Go Paperless'
    },
    myAGM: {
        id: 'header.links.My AGM',
        defaultMessage: 'My AGM'
    },
    changePassword: {
        id: 'header.links.Change Password',
        defaultMessage: 'Change Password'
    },
    updateEmail: {
        id: 'header.links.Update Email & Phone No.',
        defaultMessage: 'Update Email & Phone No.'
    },

});
